"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var ClickableTooltip_1 = require("../../../common/ClickableTooltip/ClickableTooltip");
var cashPricesLabelStyles_1 = require("./cashPricesLabelStyles");
var CashPricesLabel = function (_a) {
    var tooltipContentValues = _a.tooltipContentValues;
    var _b;
    var intl = react_intl_1.useIntl();
    var style = cashPricesLabelStyles_1.default();
    var tooltipTranslationKey = 'carDetails.label.tooltip.tooltipLink';
    var shouldRenderTooltip = ((_b = intl.formatMessage({ id: tooltipTranslationKey })) === null || _b === void 0 ? void 0 : _b.length) > 1 &&
        intl.formatMessage({ id: tooltipTranslationKey }) !== tooltipTranslationKey;
    return (<core_1.Box component="span" data-test="summary:label:cash_prices">
      <Translation_1.default id={'carDetails.label.priceLabel'}/>
      {shouldRenderTooltip && (<ClickableTooltip_1.default>
          <>
            <icons_1.Close className={style.tooltipCloseIcon} data-test="common:mui:tooltip-close-button"/>
            <Translation_1.default id={'carDetails.label.tooltip.primaryText'} values={__assign(__assign({}, tooltipContentValues), { link: (<a className={style.link} target="_blank" data-translationkey={tooltipTranslationKey} href={intl.formatMessage({ id: tooltipTranslationKey })} rel="noreferrer">
                    <Translation_1.default id={'carDetails.label.tooltip.tooltipLinkText'}/>
                  </a>) })}/>
          </>
        </ClickableTooltip_1.default>)}
    </core_1.Box>);
};
exports.default = CashPricesLabel;
